"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _inputGroup = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/input-group.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _inputGroup.default);

var InputGroupAddon = function InputGroupAddon(_ref) {
  var _classnames, _context;

  var children = _ref.children,
      className = _ref.className,
      compact = _ref.compact,
      cssNamespace = _ref.cssNamespace,
      isButton = _ref.isButton,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "compact", "cssNamespace", "isButton"]);
  var addonClasses = classnames(className, "".concat(cssNamespace, "-input-group__addon"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-input-group__addon--button"), isButton), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-input-group__addon--compact"), compact), _classnames));
  return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
    className: addonClasses
  }, otherProps), (0, _map.default)(_context = _react.default.Children.toArray(children)).call(_context, function (child) {
    if (!isButton) {
      return child;
    }

    return /*#__PURE__*/_react.default.cloneElement(child, {
      compact: compact,
      className: classnames(child.props.className, "".concat(cssNamespace, "-input-group__button"))
    });
  }));
};

InputGroupAddon.displayName = 'InputGroup.Addon';
process.env.NODE_ENV !== "production" ? InputGroupAddon.propTypes = {
  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Internal use only */
  compact: _propTypes.default.bool,

  /** Set to **true** if add-on is a button */
  isButton: _propTypes.default.bool
} : void 0;

var _default = (0, _withStyles.default)(InputGroupAddon);

exports.default = _default;